<template>
  <div class="stk-p-8">
    <Stack>
      <PageHeading>
        <template v-slot:title>
          Prospects
        </template>
        <template v-slot:subtitle>
          Discover values through a questionnaire or allow prospects to pick values directly. Embed on your site or send a direct link.
        </template>
      </PageHeading>

      <div class='values-input-cards mb-5'>
        <ValuesInputCard
          name='Behavioral Questionnaire'
          description='This behavioral questionnaire asks about values without overwhelming or offending. Embed the link for new leads, or send to specific prospects.'
          :mainLink='questionnaireLink'
          :otherLinks="[
            { name: 'Export All Responses', url: '/questionnaire/download-all-raw-responses/' },
            { name: 'Export All Personas', url: '/questionnaire/download-personality-categories/' },
            { name: 'View or Print All Questions', url: '/questionnaire/print/' },
          ]"/>
        
        <ValuesInputCard
          name='Values Picker'
          description='The values picker provides more customization by allowing prospects to select specific categories and values important to them.'
          :mainLink='wizardLink'
          :otherLinks="[
            { name: 'Customize Values Picker', url: '/advisor-dashboard/edit-wizard/' },
          ]"/>
        <ValuesInputCard
          v-if="$root.advisor.hasFeature('Risk Questionnaire')"
          name='Risk Tolerance Questionnaire'
          description='This questionnaire asks about risk tolerance without overwhelming or offending. Embed the link for new leads, or send to specific prospects.'
          :mainLink="`${questionnaireLink}?questionnaire_type=risk`"
          :otherLinks="[
            { name: 'View Methodology', url: 'https://assets-global.website-files.com/6307966dd164702a745df6dd/65946c4073193f0183606cb1_Risk%20Tolerance%20Questionnaire%20DEC%2023%20(2).pdf' },
          ]"/>

      </div>
    </Stack>

    <ProspectForm :callback='prospectCreated' class="form">Create New Prospect</ProspectForm>

    <PortfolioCardList
      portfolioType="prospect"
      :advisor="advisor"
    />
  </div>
</template>

<script>
import PortfolioCardList from '@frontend/dash3/js/components/portfolios/PortfolioCardList.vue';
import ValuesInputCard from '@frontend/ui/components/utils/ValuesInputCard.vue';
import ProspectForm from '@frontend/dash3/js/components/ProspectForm.vue';
import { PageHeading, Stack } from '@stakeui';
import Advisor from '@frontend/dash3/js/shared/Advisor.js';

export default {
  components: {
    PortfolioCardList,
    ValuesInputCard,
    ProspectForm,
    PageHeading,
    Stack,
  },
  data() {
    return {
      advisor: {},
      host: null,
    };
  },
  created: async function() {
    this.$root.$data.csrfToken = document.querySelector('[name="csrfmiddlewaretoken"]').value;
    this.advisor = new Advisor();
    this.$root.advisor = this.advisor; // Should be on root everywhere but can debug later
    this.host = window.location.host;
    this.$root.$data.csrfToken = document.querySelector('[name="csrfmiddlewaretoken"]').value;
  },
  computed: {
    questionnaireLink: function() {
      if (this.advisor.link_slug) {
        return `${window.location.protocol}//${window.location.host}/questionnaire/intro/${this.advisor.link_slug}/`;
      } else {
        return `${window.location.protocol}//${window.location.host}/questionnaire/intro/${this.advisor.slug}/`;
      }
    },
    wizardLink: function() {
      if (this.advisor.link_slug) {
        return `${window.location.protocol}//${window.location.host}/ui/visitor/wizard?advisor=${this.advisor.link_slug}`;
      } else {
        return `${window.location.protocol}//${window.location.host}/ui/visitor/wizard?advisor=${this.advisor.slug}`;
      }
    },
  },
  methods: {
    prospectCreated() {
      console.log('New prospect created');
      window.location.reload();
    },
  }
}
</script>

<style scoped>
.values-input-cards {
  display: flex;
  gap: 1.5rem;
  font-size: 0.75em;
  justify-content: start;
}

.values-input-cards > div {
  flex-grow: 1;
}

.form {
  float: right;
}
</style>